/**
 * @desc 查询水泥消耗需求年计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanYearCementConsumptionResponse>> {
  return defHttp.post({
    url: '/web/plan/year/queryPlanCementConsumption',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanYearCementConsumptionResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/year/queryPlanCementConsumption',
    data,
  });
}
